import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
// eslint-disable-next-line
import { Carousel } from '@cotyorg/ccx-organism-carousel';

const isSmallBreakpoint = currentBreakpoint =>
  currentBreakpoint && currentBreakpoint.includes('small');

const pictureComponents = ({
  images,
  currentBreakpoint,
  disableProgressiveLoading,
}) => Array.isArray(images) && (
  images.map(({ src, srcset, alt }) => (
    <Picture
      key={src}
      currentBreakpoint={currentBreakpoint}
      src={src}
      srcset={srcset}
      alt={alt}
      disableProgressiveLoading={disableProgressiveLoading}
    />
  ))
);

const ProductGalleryVertical = ({
  selectedGallery,
  currentBreakpoint,
  disableProgressiveLoading,
}) => (
  <div className="product-gallery">
    {isSmallBreakpoint(currentBreakpoint) ? (
      <Carousel
        headingLevel={3}
        carouselsStoreDataKey="productGallery"
        rightChevronIconSrc="arrow-right.svg"
        leftChevronIconSrc="arrow-left.svg"
      >
        {pictureComponents({
          images: R.prop('images', selectedGallery),
          currentBreakpoint,
          disableProgressiveLoading,
        })}
      </Carousel>
    ) : (
      pictureComponents({
        images: R.prop('images', selectedGallery),
        currentBreakpoint,
        disableProgressiveLoading,
      })
    )}
  </div>
);

ProductGalleryVertical.propTypes = {
  currentBreakpoint: PropTypes.string.isRequired,
  selectedGallery: PropTypes.shape({
    images: PropTypes.array.isRequired,
    sku: PropTypes.string.isRequired,
  }).isRequired,
  disableProgressiveLoading: PropTypes.bool,
};

export default ProductGalleryVertical;
